export const ResizableTableHandle = ({ onMouseDown, testId, className = '' }) => (
  <button
    type="button"
    className={`absolute inset-y-0 right-0 w-3 cursor-col-resize hover:bg-slate-100/70 ${className}`.trim()}
    onMouseDown={onMouseDown}
    data-testid={testId}
  >
    <span className="mx-auto block h-full w-px bg-slate-300" />
  </button>
);

export default ResizableTableHandle;